
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M18.91 13.685a1 1 0 001.414-.025 7.417 7.417 0 000-10.3 1 1 0 00-1.438 1.39 5.414 5.414 0 010 7.521 1 1 0 00.024 1.414z"}}),_c('path',{attrs:{"d":"M24.408 1.393a1.002 1.002 0 10-1.6 1.206 9.8 9.8 0 010 11.816 1.002 1.002 0 001.6 1.206 11.806 11.806 0 000-14.228zM10.186 13.965a1 1 0 00.719-1.694 5.417 5.417 0 010-7.521 1 1 0 10-1.437-1.389 7.417 7.417 0 000 10.3 1 1 0 00.718.304z"}}),_c('path',{attrs:{"d":"M6.786 15.819a1 1 0 00.2-1.4 9.808 9.808 0 010-11.816 1.003 1.003 0 00-1.6-1.21 11.81 11.81 0 000 14.228 1 1 0 00.8.4.991.991 0 00.6-.202zM16.347 11.341a3.194 3.194 0 10-2.9 0L6.249 27.893a1 1 0 101.834.8l.725-1.668 10.911-2.912 1.991 4.58a1 1 0 101.834-.8zm.053 5.138l-3.653 1.485 2.149-4.945zm-6.727 8.557l1.943-4.471 6.118 2.319zm3.868-5.56l3.537-1.437 1.446 3.326z"}})])])
          )
        }
      }
    